export default __webpack_public_path__ + "static/media/customerColor.a5c7f623.png";